import { merge, cloneDeep } from 'lodash'

const state = {
  publicSite: {
    text: '',
    url: ''
  },
  help: {
    text: '',
    video: ''
  },
  dashboard: {
    text: '',
    url: ''
  },
  mySpace: {
    text: '',
    url: ''
  },
  search: {
    text: ''
  },
  profile: {
    text: '',
    manage: {
      text: '',
      route: ''
    },
    logout: {
      text: '',
      url: ''
    }
  },
  menu: [],
  currentActive: -1,
  open: false
}

const getters = {
  getPublicSite: state => state.publicSite,
  getHelp: state => state.help,
  getMenu: state => state.menu,
  getMenuLength: state => state.menu.length,
  getSearch: state => state.search,
  getProfile: state => state.profile,
  getMySpace: state => state.mySpace,
  getDashboard: state => state.dashboard,
  getCurrentActive: state => state.currentActive,
  getOpen: state => state.open
}

const mutations = {
  UPDATE_PUBLIC_SITE: (state, object) => {
    state.publicSite = { ...object }
  },
  UPDATE_HELP: (state, object) => {
    state.help = { ...object }
  },
  UPDATE_MY_SPACE: (state, object) => {
    state.mySpace = { ...object }
  },
  UPDATE_DASHBOARD: (state, object) => {
    state.dashboard = { ...object }
  },
  UPDATE_MENU: (state, array) => {
    state.menu = [ ...array ]
  },
  UPDATE_SEARCH: (state, object) => {
    state.search = { ...object }
  },
  UPDATE_PROFILE: (state, object) => {
    state.profile = { ...object }
  },
  UPDATE_CURRENT_ACTIVE: (state, number) => {
    state.currentActive = number
  },
  UPDATE_OPEN: (state, boolean) => {
    state.open = boolean
  }
}

const actions = {
  updatePublicSite: (store, publicSite) => {
    store.commit('UPDATE_PUBLIC_SITE', merge({
      text: '',
      url: ''
    }, publicSite))
  },
  updateHelp: (store, help) => {
    store.commit('UPDATE_HELP', merge({
      text: '',
      video: ''
    }, help))
  },
  updateMySpace: (store, myspace) => {
    store.commit('UPDATE_MY_SPACE', merge({
      text: '',
      url: ''
    }, myspace))
  },
  updateDashboard: (store, dashboard) => {
    store.commit('UPDATE_DASHBOARD', merge({
      text: '',
      url: ''
    }, dashboard))
  },
  updateMenu: (store, items) => {
    store.commit('UPDATE_MENU', cloneDeep(items))
  },
  updateSearch: (store, search) => {
    store.commit('UPDATE_SEARCH', merge({
      text: ''
    }, search))
  },
  updateProfile: (store, profile) => {
    store.commit('UPDATE_PROFILE', merge({
      text: '',
      manage: {
        text: '',
        route: ''
      },
      logout: {
        text: '',
        url: ''
      }
    }, profile))
  },
  updateCurrentActive: (store, index) => {
    store.commit('UPDATE_CURRENT_ACTIVE', index)
  },
  updateOpen: (store, status) => {
    store.commit('UPDATE_OPEN', status)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
